import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_ERROR,
  USER_LIST_SET,
  USER_LIST_VOID,
  USERS_VIEW_PREFERENCES_REQ,
  SAVE_USERS_VIEW_PREFERENCES
} from './user.type'

import ApiRest from '@/api/api-rest'
import User from '@/resources/models/User'
import { usersMetaInfo } from '@/column-header/users/users-meta'
import IQCollection from '@/resources/collections/IQCollection'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  usersListStatus: '',
  usersList: null,
  usersPreferences: []
}

const getters = {
  usersListStatus: state => state.usersListStatus,
  usersList: state => state.usersList,
  usersPreferences: state => state.usersPreferences
}

// Best Practice - updates state
const mutations = {
  [USER_LIST_VOID]: state => (state.usersListStatus = ''),
  [USER_LIST_REQUEST]: state => (state.usersListStatus = 'loading'),
  [USER_LIST_SUCCESS]: state => (state.usersListStatus = 'saved'),
  [USER_LIST_SET]: (state, resp) => {
    state.usersList = resp
  },
  [USER_LIST_ERROR]: (state, errMsg) => {
    state.usersListStatus = 'error'
  },
  [USERS_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.usersPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [USERS_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUsersPrefs = data.find(pref => {
            return pref.tbl_id === 18 && pref.user_id === uid
          })
          context.commit(USERS_VIEW_PREFERENCES_REQ, currUsersPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_USERS_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [USER_LIST_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(USER_LIST_REQUEST)
      ApiRest()
        .get('/users')
        .then(({ data }) => {
          data = data.map(user => {
            return new User('id', user)
          })

          data = new IQCollection(
            data,
            { attributes: usersMetaInfo.meta.columns },
            { defaultSort: 'firstname', sortOrder: OrderByEnum.ASC }
          )

          commit(USER_LIST_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          commit(USER_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [USER_LIST_SUCCESS]: ({ commit }) => {
    commit(USER_LIST_SUCCESS)
  },
  [USER_LIST_VOID]: ({ commit }) => {
    commit(USER_LIST_VOID)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user/users.module.js